export default {"src":"/_next/static/media/Rido.da6e18fb.svg","height":43,"width":128,"blurWidth":0,"blurHeight":0};